import { render, staticRenderFns } from "./ObsoleteStatus.vue?vue&type=template&id=52a9caef"
import script from "./ObsoleteStatus.vue?vue&type=script&lang=js"
export * from "./ObsoleteStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports